import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DashboardLayout from 'layouts/Dashboard';
import { AppBar, Box, Tab, Tabs, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SincronizacionView } from './components/SincronizacionView';
import { DisponibilidadView } from './components/DisponibilidadView';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    marginTop: '150px',
    textAlign: 'center'
  },
  image: {
    display: 'inline-block',
    marginTop: '50px',
    maxWidth: '100%',
    width: '554px'
  }
});


export function SyncAvailability() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState(0);

  function handleChange(event, newValue) {
    setActiveTab(newValue);
  }

  return (
    <DashboardLayout
      title={(t && typeof t === 'function') ? (t('sync.availability.title') || 'Sincronización Disponibilidad') : 'Sincronización Disponibilidad'}
      callbackFromParent={() => { }}
      isFirstTime={true}
    >
      <Box style={{ backgroundColor: 'white' }}>
        <AppBar position='static' style={{ backgroundColor: '#333333' }}>
          <Tabs value={activeTab} onChange={handleChange} aria-label='sync-availability-tabs'>
            <Tab label={(t && typeof t === 'function') ? (t('sync.availability.tab.disponibilidad') || 'Disponibilidad') : 'Disponibilidad'} />
            <Tab label={(t && typeof t === 'function') ? (t('sync.availability.tab.sincronizacion') || 'Sincronización') : 'Sincronización'} />
          </Tabs>
        </AppBar>
        <TabPanel value={activeTab} index={0}>
          <DisponibilidadView />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <SincronizacionView />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
}

export default withStyles(styles)(SyncAvailability);
